import { createContext, useContext, useEffect, useState } from "react";
import { getCompanyDetails } from "../api/companyApi";

const UserContext = createContext();
export const useUser = () => useContext(UserContext);

export const UserProvider = ({ children }) => {
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const data = await getCompanyDetails();
        setCompany(data);
      } catch (err) {
        console.error("Company fetch failed", err);
      } finally {
        setLoading(false);
      }
    };

    fetchCompany();
  }, []);

  return (
    <UserContext.Provider value={{ company, loading }}>
      {children}
    </UserContext.Provider>
  );
};
